import type { StoreApi } from 'zustand';
import { createStore } from 'zustand';

import { createAiContextDataSnapshot } from './normalize-ai-context-data';
import { serializeContext } from './serialize-context';
import type { AiContextEntry, AiContextRegistration, SerializeContextOptions, SerializedAiContext } from './types';

export type AiContextStoreState = {
    readonly entries: ReadonlyMap<string, AiContextEntry>;
};

export type AiContextStoreActions = {
    readonly getSerializedContext: (options?: SerializeContextOptions) => SerializedAiContext;
    readonly register: (entry: AiContextRegistration) => void;
    readonly unregister: (key: string) => void;
};

export type AiContextStore = AiContextStoreActions & AiContextStoreState;

export const createAiContextStore = (): StoreApi<AiContextStore> => {
    return createStore<AiContextStore>((setState, getState) => ({
        entries: new Map(),

        getSerializedContext: (options) => {
            return serializeContext(getState().entries, options);
        },

        register: (entry) => {
            const entries = new Map(getState().entries);
            const dataSnapshot = createAiContextDataSnapshot(entry.data);

            if (dataSnapshot === null) {
                entries.delete(entry.key);
                setState({ entries });
                return;
            }

            entries.set(entry.key, {
                ...entry,
                data: dataSnapshot.normalizedData,
                registeredAt: Date.now(),
            });

            setState({ entries });
        },

        unregister: (key) => {
            const entries = new Map(getState().entries);

            entries.delete(key);

            setState({ entries });
        },
    }));
};
